
function AnimationList(){

    this.build();

}

AnimationList.prototype.build = function(){

    $(window).on('transitionDone', function () {
        document.querySelectorAll('.animation-list').forEach(function (elem) {
            ScrollTrigger.create({
                trigger: elem,
                start: 'top 80%',
                once: true,
                onEnter: function () {
                    $(elem).addClass('appeared');
                }
            });
        });

    });

};
